<template>
  <section style="position: relative;margin-right: 20%;">
    <i @click="showSelect()" class="icon iconfont icon-mulu"></i>
    <section v-if="showSelt==randomId&&canEdit" class="reason-area">
      <select v-model="seltReason" @change="reasonChange" class="select-block">
        <option value="" disabled selected>{{$t('common.Select')}}</option>
        <option :value="item.Code" v-for="(item, index) in reasonList" :key="index">{{item.Name}}</option>
      </select>
      <i v-if="seltReason" @click="clearData()" style="position: absolute;right: 20%;top:6px;z-index: 5;opacity: 0.5;" class="icon iconfont icon-guanbi colorRed"></i>
      <div v-if="(seltReason=='6'||seltReason=='7')&&canEdit">
        <textarea :id="'text-'+randomId" :maxlength="langVersion=='zh-CN'?20:50" :placeholder="$t('common.ReasonPlaceHolder')" v-model="comment"></textarea>
        <p style="text-align: right">
          <span @click="submitComment" style="color:#B62A40;padding: 6px;display: inline-block;cursor:pointer;text-decoration: underline;">{{$t('common.Ok')}}</span>
        </p>
      </div>
    </section>
  </section>
</template>
<script>
export default {
  name: 'reason',
  model: {
    prop: 'reasonData',
    event: 'changeValue'
  },
  props: {
    reasonData: {
      type: Object,
      default: function () {
        return { ReasonCode: '', ShowReason: '', Comment: '' }
      }
    },
    canEdit: {
      type: Boolean
    }
  },
  data () {
    return {
      langVersion: window.localStorage.getItem('language'),
      seltReason: this.reasonData.ReasonCode || '',
      showSelt: '',
      comment: this.reasonData.Comment || '',
      reasonList: [
        {Code: '1', Name: this.$t('common.Reason1')},
        {Code: '2', Name: this.$t('common.Reason2')},
        {Code: '3', Name: this.$t('common.Reason3')},
        {Code: '4', Name: this.$t('common.Reason4')},
        {Code: '5', Name: this.$t('common.Reason5')},
        {Code: '6', Name: this.$t('common.Reason6')},
        {Code: '7', Name: this.$t('common.Reason7')}
      ],
      randomId: 'selectId' + (new Date().getTime() + Math.random() * 1000)
    }
  },
  created () {
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
    reasonChange (data) {
      let newData = {}
      newData.ReasonCode = this.seltReason
      this.reasonList.forEach(val => {
        if (val.Code === this.seltReason) {
          newData.ShowReason = val.Name
        }
      })
      newData.Comment = ''
      if (this.seltReason === '6' || this.seltReason === '7') {
        setTimeout(() => { document.getElementById('text-' + this.randomId).focus() }, 200)
      } else {
        this.$emit('changeValue', newData)
        this.showSelt = ''
      }
    },
    submitComment () {
      let newData = {}
      newData.ReasonCode = this.seltReason
      if (this.seltReason === '6') {
        newData.ShowReason = this.$t('common.Reason6')
      } else {
        newData.ShowReason = this.$t('common.Reason7')
      }
      newData.Comment = this.comment
      if (this.comment === '' || this.comment.trim() === '') {
        this.$commonJs.alertTips({
          type: 'error',
          content: this.$t('common.EmptyContent'),
          stayTime: 5
        })
        document.getElementById('text-' + this.randomId).focus()
        return false
      }
      this.$emit('changeValue', newData)
      this.showSelt = ''
    },
    clearData () {
      let newData = { ReasonCode: '', ShowReason: '', Comment: '' }
      this.seltReason = ''
      this.$emit('changeValue', newData)
    },
    showSelect () {
      setTimeout(() => {
        if (this.canEdit) {
          if (this.showSelt === '') {
            this.showSelt = this.randomId
          } else {
            this.showSelt = ''
          }
        }
      }, 50)
    }
  }
}
</script>
<style scoped>
  .reason-area{
    position: absolute;left: 20px;top: -6px;
  }
  .reason-area .select-block{
    position: relative;
    background-color: #fff;
    padding: 4px 16px 5px 5px;
    border-radius: 50px;
    border: 1px solid #c73343;
    width: 120px;
    z-index: 1;
    outline: none;
  }
  .reason-area div{
    width: 110%;
    min-width: 80px;
    background-color: #ffffff;
    position: relative;
    z-index: 1;
    box-shadow: 0px 0px 5px 0px #ccc;
  }
  .reason-area textarea{
    position: relative;
    width: calc(100% - 12px);
    height: 30px;
    padding: 6px;
    resize: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/myComponents/reason.vue